import MasterBusiness from "../pages/MasterData/Business";
import MasterBusinessTrx from "../pages/MasterData/BusinessTrx";
import MasterJobTitle from "../pages/MasterData/JobTitle";
import MasterUserAccount from "../pages/MasterData/UserAccount";
import MasterBank from "../pages/MasterData/Bank";
import MasterDepartment from "../pages/MasterData/Department";
import MasterVendor from "../pages/MasterData/Vendor";
import CreateReceiptSubmission from "../pages/Transaction/CreateReceiptSubmission";
import ReportReceiptSubmission from "../pages/Transaction/ReportReceiptSubmission";
import CloseReceipt from "../pages/Transaction/CloseReceipt";
import WithdrawalReceipt from "../pages/Transaction/WithdrawalReceipt";
import ApprovalMasterVendor from "../pages/Configuration/ApprovalMasterVendor";
import MasterUserPosition from "../pages/MasterData/UserPosition";
import TransactionCodeWithProvider from "../pages/MasterData/TransactionCode/TransactionCode";

const openPaths = [
  {
    path: "/master-data/business-transaction",
    element: <MasterBusinessTrx />,
  },
  {
    path: "/master-data/job-title",
    element: <MasterJobTitle />,
  },
  {
    path: "/master-data/business",
    element: <MasterBusiness />,
  },
  {
    path: "/master-data/user-account",
    element: <MasterUserAccount />,
  },
  {
    path: "/master-data/bank",
    element: <MasterBank />,
  },
  {
    path: "/master-data/departemen",
    element: <MasterDepartment />,
  },
  {
    path: "/master-data/vendor",
    element: <MasterVendor />,
  },
  {
    path: "/master-data/user-position",
    element: <MasterUserPosition />,
  },
  {
    path: "/master-data/transaction-code",
    element: <TransactionCodeWithProvider />,
  },
  {
    path: "/transaksi/pengajuan-bon",
    element: <CreateReceiptSubmission />,
  },
  {
    path: "/transaksi/pengajuan-bon/:trx_id",
    element: <CreateReceiptSubmission />,
  },
  {
    path: "/transaksi/pengajuan-bon/:trx_id/:extend_bm",
    element: <CreateReceiptSubmission />,
  },
  {
    path: "/transaksi/riwayat-pengajuan-bon",
    element: <CreateReceiptSubmission />,
  },
  {
    path: "/transaksi/laporan-pengajuan-bon",
    element: <ReportReceiptSubmission />,
  },
  {
    path: "/transaksi/close-bon-putih-ijiran",
    element: <CloseReceipt pageName="Close-bon-putih-ijiran" />,
  },
  {
    path: "/transaksi/verifikasi-bon",
    element: <div><CloseReceipt pageName="Verifikasi-bon" /></div>,
  },
  {
    path: "/transaksi/pencairan-bon",
    element: <WithdrawalReceipt />,
  },
  {
    path: "/transaksi/pencairan-bon/riwayat",
    element: <WithdrawalReceipt />,
  },
  {
    path: "/konfigurasi/approval-master-vendor",
    element: <ApprovalMasterVendor />,
  },
];

export default openPaths;
